import React from 'react'

import { useActivePower } from '../../../hooks'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'

export default function ActivePowerChartPresenter() {
  const { filter, activePowerQuery: query}= useActivePower()


      
  if(query.isLoading) {
    return <ProfessionalChartLoader metricName="Puissance Active" />
}

if(query.isError && query.error) {
  const error = query.error as Error

  return <ChartErrorView metricName="Puissance Active" error={error} />
}

const dataChart = createList(filter.aggregateWindow || '1mo', filter, query.data)
  return (
    <ChartLineView


    xAxisData ={dataChart.listx.map((item) => formatDateByPeriod(item, filter.aggregateWindow || '1mo'))}
    data ={dataChart.listValue}
    label='Puissance Active (W)'
    unit='W'


    />
  )
}


